import { ChartGrowthRate } from './chartGrowthRate'
import { ChartValue } from './chartValue'

export const LeftChart = () => {
  return (
    <div className="w50 h100 flexColumn" style={{ gap: 12 }}>
      <ChartValue />
      <ChartGrowthRate />
    </div>
  )
}
